import {
    SAVE_COMPANYADDINFO_STARTED,    SAVE_COMPANYADDINFO_SUCESS,    SAVE_COMPANYADDINFO_FAILED,
    GET_COMPANYADDINFO_STARTED,    GET_COMPANYADDINFO_SUCESS,    GET_COMPANYADDINFO_FAILED,
    ADD_COMPANYADDINFO_STARTED,    ADD_COMPANYADDINFO_SUCESS,    ADD_COMPANYADDINFO_FAILED,

    UPDATE_LAWFIRM_STARTED,    UPDATE_LAWFIRM_SUCESS,    UPDATE_LAWFIRM_FAILED,
    GET_LAWFIRM_STARTED,    GET_LAWFIRM_SUCESS,    GET_LAWFIRM_FAILED,
    ADD_LAWFIRM_STARTED,    ADD_LAWFIRM_SUCESS,    ADD_LAWFIRM_FAILED,

    UPDATE_ATTORNEY_STARTED,    UPDATE_ATTORNEY_SUCESS,    UPDATE_ATTORNEY_FAILED,
    GET_ATTORNEY_STARTED,    GET_ATTORNEY_SUCESS,    GET_ATTORNEY_FAILED,
    ADD_ATTORNEY_STARTED,    ADD_ATTORNEY_SUCESS,    ADD_ATTORNEY_FAILED,

    UPDATE_CORPORATE_STARTED,    UPDATE_CORPORATE_SUCESS,    UPDATE_CORPORATE_FAILED,
    GET_CORPORATE_STARTED,    GET_CORPORATE_SUCESS,    GET_CORPORATE_FAILED,
    ADD_CORPORATE_STARTED,    ADD_CORPORATE_SUCESS,    ADD_CORPORATE_FAILED,
   
} from '../actions/AddCorporate';

const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const companyData = (state = intialData, action: any) => {
  
 
    switch (action.type) {
        case SAVE_COMPANYADDINFO_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SAVE_COMPANYADDINFO_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_COMPANYADDINFO_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case GET_COMPANYADDINFO_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_COMPANYADDINFO_SUCESS:
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_COMPANYADDINFO_FAILED:
     return {
       ...state,
       isLoading: true,
     };
     case ADD_COMPANYADDINFO_STARTED:           
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case ADD_COMPANYADDINFO_SUCESS:
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case ADD_COMPANYADDINFO_FAILED:
     return {
       ...state,
       isLoading: true,
     };
    
 default:
    return state;
}

}


export const visaCareFirmData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case UPDATE_LAWFIRM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_LAWFIRM_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_LAWFIRM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_LAWFIRM_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_LAWFIRM_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_LAWFIRM_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case ADD_LAWFIRM_STARTED:           
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case ADD_LAWFIRM_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case ADD_LAWFIRM_FAILED:
   return {
     ...state,
     isLoading: true,
   };
default:
  return state;
}

}

export const visaCareAttorneyData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case UPDATE_ATTORNEY_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_ATTORNEY_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_ATTORNEY_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_ATTORNEY_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_ATTORNEY_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_ATTORNEY_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case ADD_ATTORNEY_STARTED:           
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case ADD_ATTORNEY_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case ADD_ATTORNEY_FAILED:
   return {
     ...state,
     isLoading: true,
   };
default:
  return state;
}

}

export const visacareCorporateData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case UPDATE_CORPORATE_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_CORPORATE_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_CORPORATE_FAILED:
    return {
      ...state,
      isLoading: true
    };
    case GET_CORPORATE_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_CORPORATE_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_CORPORATE_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case ADD_CORPORATE_STARTED:           
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case ADD_CORPORATE_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case ADD_CORPORATE_FAILED:
   return {
     ...state,
     isLoading: true,
   };
default:
  return state;
}

}